import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-list-company',
  templateUrl: './list-company.component.html',
  styleUrls: ['./list-company.component.css']
})
export class ListCompanyComponent implements OnInit {
  respPeer: any;
  respDel: any;
  respEdit: any;
  respcreate: any;
  peerData: any;
  errCounter = 0;
  companyPid ='';
  companyName ='';
  companyID='';
  companyNewName ='';
  companyNewID='';
  companyLogo='';
  emailAddress='';
  peerGroup='';

  compName="";
  compID="";
  compEmail="";
  industryType="";
  compPeer="";
  resp1Peer: any;
  peer1Data: any;
  industryTypeData: any;



  loaderVisibility: boolean = false;
  editVisibility: boolean = false;

  perPageRow = this._rest.PER_PAGE_ROW;
  curPage = 1;
  totalRows = 0;
  pages = [];
  noOfRows=0;
  downLoadPath = this._rest.FILE_PATH;
  constructor(@Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,private router: Router, private _rest: RestapiService) { }

  ngOnInit(){
  	this.loaderVisibility=false;
  	//this.editVisibility=false;
    this.industryTypeData=['General','Standalone Health','Specialized','Reinsurance'];
  	
    const peer1Data = {}
    this._rest.getPeerGroup(peer1Data).subscribe((res) => {
      this.resp1Peer = res;
      this.peer1Data = this.resp1Peer.details;
      //console.log(JSON.stringify(this.respPeer.details));
      
    })
    this.searchCompany(1);
  }
  deleteCompany(id){
  	if(confirm("Are you sure to delete?")){
  		//alert(id)
  		var delData = {"companyId":id}
  		this._rest.companydelete(delData).subscribe((res) => {
  			this.respDel = res;
	  		if(this.respDel.details != undefined){
	  			//alert("deleted")
	  			//window.location.reload();
          this.refreshList();
	  		} else {
	  			alert("Oops! Error");
	  		}
	  		
	  	})
  	}
  }
  refreshList(){
    this.companyPid ='';
    this.companyName ='';
    this.companyID='';
    this.companyNewName ='';
    this.companyNewID='';
    this.companyLogo='';
    this.emailAddress='';
    this.peerGroup='';
    this.editVisibility=false;
    this.ngOnInit()
  }
  updateCompany(){
    const files = <HTMLInputElement>document.getElementById('cLogo');
    const fd = new FormData();
  	if(this.companyNewName=="" && this.companyNewID=="" && files.files[0]== undefined){
  		alert("Please select alreast one field");
  	} else {
  		var editData = {"companyId":this.companyPid,"companyName":this.companyNewName,"companyCode":this.companyNewID}
      fd.append('companyId', this.companyPid);
      fd.append('companyName', this.companyNewName);
      fd.append('companyCode', this.companyNewID);
      if (files.files[0]!= undefined){
        fd.append('logo', files.files[0]);
      }
      
  		this._rest.companyedit(fd).subscribe((res) => {
  		console.log(res)
  			this.respEdit = res;
	  		if(this.respEdit.details != undefined){
	  			//alert("deleted")
	  			alert("Data updated successfully")
	  			//window.location.reload();
          this.refreshList()
	  		} else {
	  			alert("Oops! Error");
	  		}
	  		
	  	})
  		//alert(this.companyNewID)
  	}

  }
  showUpdate(companyDetails){
  	this.editVisibility=true;
  	//document.getElementById('editCont').style.display = ''; 
  	this.companyName =companyDetails.companyName;
  	this.companyID=companyDetails.companyCode;
  	this.companyPid=companyDetails.companyId
  	console.log(companyDetails);
    let scrollToTop = window.setInterval(() => {
        let pos = window.pageYOffset;
        if (pos > 0) {
            window.scrollTo(0, pos - 20); // how far to scroll on each step
        } else {
            window.clearInterval(scrollToTop);
        }
    }, 16);
  }
  searchCompany(curPage){
    this.curPage= curPage;
    const searchData = {
      "companyCode":this.compID,
      "peerId":this.compPeer,
      "industryType":this.industryType,
      "companyName":this.compName,
      "companyEmail":this.compEmail,
      "page": this.curPage,
      "limit":this.perPageRow
    };
    this.peerData = [];
    this._rest.companyListWithSearch(searchData).subscribe((res) => {
      this.respPeer = res;
      if(this.respPeer.error==0){

        this.peerData = this.respPeer.resp.data;
        this.totalRows = this.respPeer.resp.info;
        this.noOfRows=this.respPeer.resp.data.length;
        this.pages=[];
        for (var i=1;i<=Math.ceil(this.totalRows/this.perPageRow);i++){
          this.pages.push(i);
        }
      } else {
        this.totalRows = 0;
        this.noOfRows = 0;
        this.pages=[];
      }
      console.log(JSON.stringify(this.respPeer));
      
    })
  }
}
